import { c as _c } from "react/compiler-runtime";
import { AspectRatio, Box, Heading, Image, Text, VStack, Flex, Separator } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { useHover } from '@uidotdev/usehooks';
type FounderInterviewCardProps = {
  image?: string;
  large?: boolean;
  subject?: string;
  subjectLogo?: string;
  summary?: string;
  tag?: string;
  title?: string;
  url?: string;
};
export const FounderInterviewCard = props => {
  const $ = _c(13);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const [ref, hovering] = useHover();
  const t0 = props.url || "#";
  let t1;
  if ($[0] !== getBreakpointValue || $[1] !== hovering || $[2] !== props.image || $[3] !== props.large || $[4] !== props.subject || $[5] !== props.subjectLogo || $[6] !== props.summary || $[7] !== props.title || $[8] !== ref) {
    t1 = props.large ? <Flex ref={ref} align="flex-start" aspectRatio={getBreakpointValue([null, 1, 1.7777777777777777, 1.7777777777777777, 2.3333333333333335])} background={`url(${props.image})`} backgroundPosition="center right" backgroundRepeat="no-repeat" backgroundSize="cover" bgColor="black" borderRadius="2xl" boxShadow="sm" direction="column" height="full" justify="flex-end" overflow="hidden" padding={getBreakpointValue([0, 0, 4])} position="relative" transition="all 0.2s ease-in" width="full"><VStack align="flex-start" bgColor="colorPalette.bg" borderRadius="2xl" gap={10} height={getBreakpointValue(["full", "full", "fit-content"])} justify="flex-end" maxWidth={getBreakpointValue(["full", "full", "400px"])} padding={10} width="full">{props.subjectLogo && <Box h="auto" overflow="hidden" position="relative" w="8em"><Image filter={{
            _light: "invert(1)",
            _dark: "invert(0)"
          }} h="100%" objectFit="contain" src={props.subjectLogo} w="100%" /></Box>}<VStack align="flex-start"><Heading size={getBreakpointValue(["xl", "2xl", "xl", "3xl", "4xl"])}>{props.title}</Heading><Text fontSize="2xl">{"with "}{props.subject}</Text></VStack></VStack></Flex> : <Flex ref={ref} align="center" borderRadius="2xl" direction={getBreakpointValue(["column", "column", "row", "row"])} gap={20} height="full" justify="flex-start" overflow="hidden" transition="all 0.2s ease-in" width="full"><Box flex={1} position="relative" width="full"><AspectRatio borderRadius="2xl" boxShadow="sm" overflow="hidden" ratio={getBreakpointValue([1.7777777777777777])} width="full"><Box background={`url(${props.image})`} backgroundPosition="center center" backgroundRepeat="no-repeat" backgroundSize="cover" borderRadius="2xl" overflow="hidden" transform={hovering && "scale(1.1)"} transition="all 0.2s ease-in" width="full" /></AspectRatio></Box><VStack align="flex-start" flex={1} gap={6} maxWidth="container.sm">{props.subjectLogo && <><Box h="auto" overflow="hidden" position="relative" w="6em"><Image filter={{
              _light: "invert(1)",
              _dark: "invert(0)"
            }} h="100%" objectFit="contain" src={props.subjectLogo} w="100%" /></Box><Separator borderColor="colorPalette.border/30" width="full" /></>}<VStack align="flex-start" gap={4}><VStack align="flex-start"><Heading size={getBreakpointValue(["xl", "2xl", "xl", "2xl", "3xl"])}>{props.title}</Heading><Text color="colorPalette.fg" fontSize="lg" fontWeight="medium">{"with "}{props.subject}</Text></VStack><Text color="colorPalette.fg/75" fontSize="md">{props.summary}</Text></VStack></VStack></Flex>;
    $[0] = getBreakpointValue;
    $[1] = hovering;
    $[2] = props.image;
    $[3] = props.large;
    $[4] = props.subject;
    $[5] = props.subjectLogo;
    $[6] = props.summary;
    $[7] = props.title;
    $[8] = ref;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== t0 || $[11] !== t1) {
    t2 = <Box width="full"><NextLink href={t0} prefetch={false}>{t1}</NextLink></Box>;
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};